import { async } from 'q';
import store from 'store';
import { getFontStyleandFontWeight } from './properties';
import _merge from 'lodash.merge';
import { updateVisiblePopover } from 'store/slices/pageEditorCanvasSlice';
import {
  updatePageDetailsById,
  updatePageChildOrderList,
  updatePageDetails,
} from 'store/slices/pageEditorModelDataSlice';
import { widgetDataConstant } from 'utils/pageEditor/widgetDataConstants';
import { v4 as uuid } from 'uuid';
import { CommonConstants, DESKTOPRES } from 'utils/pageEditor/CommonConstants';
import { debounce } from 'lodash';
import {
  LEFT_TOP,
  CENTER_TOP,
  RIGHT_TOP,
  LEFT_CENTER,
  CENTER,
  RIGHT_CENTER,
  LEFT_BOTTOM,
  CENTER_BOTTOM,
  RIGHT_BOTTOM,
  LEFT,
  RIGHT,
  TOP,
  BOTTOM,
} from 'utils/pageEditor/CommonConstants';
import styled from 'styled-components';
export const fnKeyExists = (obj, key) => {
  if (!obj || (typeof obj !== 'object' && !Array.isArray(obj))) {
    return false;
  } else if (obj.hasOwnProperty(key)) {
    return true;
  } else if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      const result = fnKeyExists(obj[i], key);
      if (result) {
        return result;
      }
    }
  } else {
    for (const k in obj) {
      const result = fnKeyExists(obj[k], key);
      if (result) {
        return result;
      }
    }
  }

  return false;
};

export const fnFindAndUpdateValueByKey = (obj = {}, property, newValue, oldValue) => {
  let currentObj = JSON.parse(JSON.stringify(obj));
  function traverse(traverseObj) {
    for (var i in traverseObj) {
      if (i === property) {
        if (Array.isArray(traverseObj[property])) {
          traverseObj[property].splice(traverseObj[property].indexOf(oldValue), 1, newValue);
        } else {
          traverseObj[property] = newValue;
        }
        break;
      } else if (!!traverseObj[i] && typeof traverseObj[i] == 'object') traverse(traverseObj[i]);
    }
  }
  traverse(currentObj);
  return currentObj;
};

export function findAndUpdateValueByKey(obj = {}, property, value) {
  function traverse(traverseObj) {
    for (var i in traverseObj) {
      if (i === property) {
        traverseObj[property] = value;

        break;
      } else if (!!traverseObj[i] && typeof traverseObj[i] == 'object') traverse(traverseObj[i]);
    }
  }

  traverse(obj);

  return obj;
}

export function findAndUpdateObjectByKey(obj = [], index, value = {}, key) {
  let updatedObject = JSON.parse(JSON.stringify(obj));
  updatedObject[index][key] = value[key];
  //console.log("updatedObject",updatedObject)
  return updatedObject;
}

export const getCustomColor = ({ color, opacity, themePresetsandProps }) => {
  const hexToRgbA = (hex, opacity) => {
    var c;
    var o = opacity / 100;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `, ${o})`;
    }else{
      return color
    }
    throw new Error('Bad Hex');
  };

  const getPresetVal = color => {
    const list = color?.split('-');
    const clrVal = list[1];
    return themePresetsandProps?.[clrVal];
  };
  const colorVal =
    color && opacity
      ? color?.includes('pre')
        ? getPresetVal(color)
        : color === 'transparent'
        ? 'transparent'
        : hexToRgbA(color, opacity)
      : '';

  return colorVal;
};
export const findPropValue = ({ list, propCode, attrCode }) => {
  const index = list?.findIndex(val => val?.propCode === propCode);
  const attrVal = index !== -1 && index !== undefined ? list[index]?.[attrCode] : '';
  return attrVal;
};
export const findStylePropVal = ({ list, code, themePresetsandProps, obj, isCustom }) => {
  const Theme = 'theme';
  const Corner = 'corner';
  const Shadow = 'shadow';

  const getPropVal = (propCode, attrCode) => {
    const propValue =
      findPropValue({
        list: list,
        propCode: propCode,
        attrCode: attrCode,
      }) || '';
    return propValue;
  };
  switch (code) {
    case 'corner':
      const defaultradius = getPropVal(Corner, 'expandedValue') || '0';
      const cornderExpanded = getPropVal(Corner, 'expanded');

      const topLeft = getPropVal(Corner, 'topLeft') || '0';

      const topRight = getPropVal(Corner, 'topRight') || '0';

      const bottomLeft = getPropVal(Corner, 'bottomLeft') || '0';

      const bottomRight = getPropVal(Corner, 'bottomRight') || '0';

      const corner = isCustom
        ? cornderExpanded
          ? `${topLeft === Theme ? themePresetsandProps?.corner : topLeft}px ${
              topRight === Theme ? themePresetsandProps?.corner : topRight
            }px ${bottomLeft === Theme ? themePresetsandProps?.corner : bottomLeft}px ${
              bottomRight === Theme ? themePresetsandProps?.corner : bottomRight
            }px`
          : `${defaultradius === Theme ? themePresetsandProps?.corner : defaultradius}px`
        : obj?.getThemeCorner === 'Y'
        ? `${themePresetsandProps?.corner}px`
        : '0px';
      //console.log('button corner', corner);

      return corner;

    case 'shadow':
      const hOffset = getPropVal(Shadow, 'X') || '0';

      const vOffset = getPropVal(Shadow, 'Y') || '0';

      const shadowBlur = getPropVal(Shadow, 'blur') || '0';

      const shadowSpread = getPropVal(Shadow, 'spread') || '0';

      const shadowColor = getPropVal(Shadow, 'color') || '';

      const shadowOpacity = getPropVal(Shadow, 'opacity') || '0';
      const RGBAShadowColor = getCustomColor({
        color: shadowColor,
        opacity: shadowOpacity,
        themePresetsandProps: themePresetsandProps,
      });
      const themeShadow = themePresetsandProps?.shadow;
      const thmshdwX = themeShadow?.hoffset;
      const thmshdwY = themeShadow?.voffset;
      const thmshdwBlur = themeShadow?.blur;
      const thmshdwSpread = themeShadow?.spread;
      const thmshdwColor = getCustomColor({
        color: themeShadow?.color,
        opacity: themeShadow?.opacity,
        themePresetsandProps: themePresetsandProps,
      });

      const shadow = isCustom
        ? `${hOffset === Theme ? thmshdwX : hOffset}px ${
            vOffset === Theme ? thmshdwY : vOffset
          }px ${shadowBlur === Theme ? thmshdwBlur : shadowBlur}px ${
            shadowSpread === Theme ? thmshdwSpread : shadowSpread
          }px ${RGBAShadowColor}`
        : obj?.getThemeShadow === 'Y'
        ? `${thmshdwX}px ${thmshdwY}px ${thmshdwBlur}px ${thmshdwSpread}px ${thmshdwColor}`
        : 'none';

      return shadow;
    case 'border':
      const fnFindPropElement = ({ list, propCode }) => {
        const index = list?.findIndex(val => val?.propCode === propCode);
        const propObj = index !== -1 && index !== undefined ? list[index] : null;
        return propObj;
      };

      const border = fnFindPropElement({ list: list, propCode: 'stroke' });
      const borderstyle = border?.style || '';
      const borderWidth = border?.thickness || 0;
      const borderColor = border?.color || '';
      const borderOpacity = border?.opacity || '';
      const RGBABorderColor =
        borderColor &&
        borderOpacity &&
        getCustomColor({
          color: borderColor,
          opacity: borderOpacity,
          themePresetsandProps: themePresetsandProps,
        });
      const thmBorderThickness = themePresetsandProps?.border?.thickness;
      const thmBorderStyle = themePresetsandProps?.border?.style;
      let borderVal = {};
      if (isCustom) {
        if (
          border?.thicknessGeneralChecked === 'true' ||
          border?.thicknessGeneralChecked === true
        ) {
          const objVal = `${borderWidth === Theme ? thmBorderThickness : borderWidth}px ${
            borderstyle === 'theme' ? thmBorderStyle : borderstyle
          } ${RGBABorderColor}`;

          borderVal = {
            border: objVal,
          };
        } else {
          const left = border?.thicknessLeft;
          const top = border?.thicknessTop;
          const right = border?.thicknessRight;
          const bottom = border?.thicknessBottom;
          borderVal = {
            borderWidth: `${top === Theme ? thmBorderThickness : top}px 
           ${right === Theme ? thmBorderThickness : right}px
           ${bottom === Theme ? thmBorderThickness : bottom}px
           ${left === Theme ? thmBorderThickness : left}px`,
            borderColor: RGBABorderColor,
            borderStyle: borderstyle === 'theme' ? thmBorderStyle : borderstyle,
          };
        }
      } else {
        const borderColor = getCustomColor({
          color: obj?.color,
          opacity: '100',
          themePresetsandProps: themePresetsandProps,
        });

        const objVal =
          obj?.getThemeBorder === 'Y'
            ? `${thmBorderThickness}px ${thmBorderStyle} ${borderColor}`
            : 'none';
        //console.log('obj border', obj, objVal);
        borderVal = {
          border: objVal,
        };
      }

      return borderVal;

    case 'focus':
      return;
    default:
      return null;
  }
};

export function marginPaddingConstruct(appearance) {
  const divStyle = {};

  if (appearance?.marginandPadding) {
    let marginValue = '';
    const marginExtended = appearance?.marginandPadding?.marginGeneral?.marginExtended;
    const marginDefaultValue = appearance?.marginandPadding?.marginGeneral?.marginDefaultValue;
    if (!appearance?.marginandPadding?.marginGeneral?.marginGeneralChecked) {
      marginValue = `${marginExtended?.marginTop}px ${marginExtended?.marginRight}px ${marginExtended?.marginBottom}px ${marginExtended?.marginLeft}px`;
    } else {
      marginValue = `${marginDefaultValue}px`;
    }
    divStyle.margin = marginValue;
  }
  return divStyle;
}

export function canvasHeightAutoInc() {
  const canvasDefaultHeight = document
    .querySelector('.react-transform-wrapper')
    .getBoundingClientRect()?.height;
  const mainCanvasWidgetList = this?.pageEditorModelDataStateClone?.filter(
    value => !value?.parentContainerWidgetId,
  );
  let widgetsTotalHeight = 0;
  mainCanvasWidgetList.forEach(widgetObj => {
    if (widgetObj?.widgetStyleDtls?.height) {
      widgetsTotalHeight += Number(widgetObj?.widgetStyleDtls?.height?.replace('px', ''));
    }
  });
  const heightDiffCheck =
    this?.invokeType === 'resize'
      ? parseInt(this?.pageHeight) - widgetsTotalHeight
      : parseInt(this?.pageHeight) - widgetsTotalHeight <= 20 ||
        widgetsTotalHeight >= parseInt(this?.pageHeight);
  if (heightDiffCheck) {
    const updatePageDtlsReq = {
      pageId: this?.pageId,
      applicationId: this?.applicationId,
    };
    const finalCanvasHeight =
      canvasDefaultHeight >= widgetsTotalHeight ? canvasDefaultHeight : widgetsTotalHeight + 100;
    const pageHeightReq = { pageHeight: finalCanvasHeight };
    const pageEditorModelArray = [...this?.pageEditorModelDataPageList];
    const currentPageEditorModelDataPageList = findAndUpdateObjectByKey(
      pageEditorModelArray,
      this?.activePageFindIndex,
      pageHeightReq,
      'pageHeight',
    );
    this?.dispatch(
      this?.updateCurrentPageDtls({
        ...this?.currentPageDtls,
        //undoStepValue: this?.currentPageDtls?.undoStepValue + 1,
        //redoStepValue: 0,
        pageHeight: finalCanvasHeight,
      }),
    );
    this?.dispatch(
      this?.setPageEditorModelData({ pageEditorModelData: currentPageEditorModelDataPageList }),
    );
    this?.updatePageDtlsfn({ reqObj: { ...updatePageDtlsReq, pageHeight: finalCanvasHeight } });
  }
}

export function canvasHeightManualInc() {
  const finalCanvasHeight = this?.finalPageHeight;
  const pageHeightReq =
    this?.device === CommonConstants?.DESKTOP
      ? { pageHeight: finalCanvasHeight }
      : this?.device === CommonConstants?.TABLET_LANDSCAPE
      ? { tabLandscapePageHeight: finalCanvasHeight }
      : this?.device === CommonConstants?.TABLET_VERTICAL
      ? { tabPotraitPageHeight: finalCanvasHeight }
      : { mobilePageHeight: finalCanvasHeight };
  const heightBasedOnDevice =
    this?.device === CommonConstants?.DESKTOP
      ? 'pageHeight'
      : this?.device === CommonConstants?.TABLET_LANDSCAPE
      ? 'tabLandscapePageHeight'
      : this?.device === CommonConstants?.TABLET_VERTICAL
      ? 'tabPotraitPageHeight'
      : 'mobilePageHeight';
      const pageEditorModelDataPageList =
        store?.getState()?.pageEditorModelData?.pageEditorModelData || [];
      const activePageFindIndex = pageEditorModelDataPageList?.findIndex(
        value => value.pageId === this?.pageId,
      );
  const pageEditorModelArray = [...pageEditorModelDataPageList];
  const updatePageDtlsReq = {
    pageId: this?.pageId,
    applicationId: this?.applicationId,
    usrActionId: uuid(),
    primaryUsrActionId: uuid(),
  };
  const currentPageEditorModelDataPageList = findAndUpdateObjectByKey(
    pageEditorModelArray,
    activePageFindIndex,
    pageHeightReq,
    heightBasedOnDevice,
  );
  this?.dispatch(
    this?.updateCurrentPageDtls({
      ...this?.currentPageDtls,
      undoStepValue: this?.currentPageDtls?.undoStepValue + 1,
      redoStepValue: 0,
      [heightBasedOnDevice]: finalCanvasHeight,
    }),
  );
  this?.dispatch(
    this?.setPageEditorModelData({ pageEditorModelData: currentPageEditorModelDataPageList }),
  );
  this?.updatePageDtlsfn({
    reqObj: { ...updatePageDtlsReq, [heightBasedOnDevice]: finalCanvasHeight },
  });
}

export const updateWidgetOrderApiAndRedux = function () {
  if (this?.updatedWidgetDetails) {
    const currentPageDtls=store.getState()?.pageEditorCanvas?.currentPageDtls
    //console.log('updatedWidgetDetails check: ', this?.newWidgetData?.dragFrom);
    //console.log('uw  this check: ', this);
    const droppedFromContainerToMainCanvas = this?.widgetOrder?.droppedFromContainerToMainCanvas;
    const droppedFromMainCanvasToContainer = this?.widgetOrder?.droppedFromMainCanvasToContainer;
    // const pageList = JSON.parse(JSON.stringify(this?.pageCanvas));
    const notSideBar = this?.newWidgetData?.dragFrom !== 'sidebar';
    const pageEditorModelData = store?.getState()?.pageEditorModelData?.pageEditorModelData || [];
    const activePageFindIndex = pageEditorModelData?.findIndex(value => value.pageId === this?.pageId);
    const pageEditorModelDataState = pageEditorModelData?.[activePageFindIndex]?.pageWidgetDtlsList|| [];
    let draftedPageId = null;
      draftedPageId = pageEditorModelDataState?.filter(
        widgetDtls => widgetDtls?.widgetId === this?.newWidgetData?.parentContainerWidgetId,
      )[0]?.pageId;
    const requestConfig = {
      pageId: draftedPageId ? draftedPageId : currentPageDtls?.pageId,
      applicationId: this?.applicationId,
      widgetId: this?.newWidgetData?.widgetId,
      usrActionId: uuid(),
      primaryUsrActionId: uuid(),
    };

    //updatePageChildOrderList
    // this?.dispatch(updatePageDetailsById(
    //   {
    //     callBack: (pageDetils) => {
    //       const currentPageIndex = pageDetils?.findIndex(pageValue => pageValue.pageId === this?.pageId);
    //       return {
    //         latestWidgetNumber: this?.newWidgetData?.latestWidgetNumber,
    //         pageWidgetDtlsList: this?.updatedWidgetDetails,
    //         currentPageIndex,
    //       }
    //     }
    //   }
    // ));
    this?.dispatch(
      updatePageDetails({
        activePageId: this?.pageId,
        newPageDetails: {
          latestWidgetNumber: this?.newWidgetData?.latestWidgetNumber,
          pageWidgetDtlsList: this?.updatedWidgetDetails,
        },
      }),
    );
    // const currentPageIndex = pageList?.findIndex(pageValue => pageValue.pageId === this?.pageId);
    // pageList[currentPageIndex].pageWidgetDtlsList = this?.updatedWidgetDetails;
    // pageList[currentPageIndex].latestWidgetNumber =
    //   this?.newWidgetData?.latestWidgetNumber;
    // pageList[this?.currentActivePageIndex].pageWidgetDtlsList = this?.updatedWidgetDetails;
    // pageList[this?.currentActivePageIndex].latestWidgetNumber =
    //   this?.newWidgetData?.latestWidgetNumber;

    if (
      this?.newWidgetData?.dragFrom === 'sidebar' &&
      (this?.newWidgetData?.pageReusableWidgetId === null ||
        this?.newWidgetData?.pageReusableWidgetId === undefined)
    ) {
      this?.createWidgetApiCall?.({
        requestConfig: {
          ...this?.newWidgetData,
          pageId: draftedPageId ? draftedPageId : currentPageDtls?.pageId
        },
      });
    }

    if (
      this?.isPageChildWidgetOrderList ||
      droppedFromContainerToMainCanvas ||
      droppedFromMainCanvasToContainer
    ) {
      let newChildOrderWidgetList = this?.childOrderWidgetList;
      if (notSideBar && droppedFromContainerToMainCanvas) {
        newChildOrderWidgetList = this?.widgetOrder?.currentChildWidgetOrderedList;
      } else if (notSideBar && droppedFromMainCanvasToContainer) {
        newChildOrderWidgetList = this?.widgetOrder?.prevChildWidgetOrderedList;
      }
      // pageList[this?.currentActivePageIndex].pageChildWidgetOrderList = newChildOrderWidgetList;
      // pageList[currentPageIndex].pageChildWidgetOrderList = newChildOrderWidgetList;
      this?.dispatch(
        updatePageChildOrderList({
          activePageId: this?.pageId,
          pageChildWidgetOrderList: newChildOrderWidgetList,
          pageChildRestrictedWidgetOrderList: this?.pageChildRestrictedWidgetOrderList,
        }),
      );

      requestConfig.pageChildWidgetOrderList = newChildOrderWidgetList;
      const reqObj = {
        pageId: draftedPageId ? draftedPageId : currentPageDtls?.pageId,
        applicationId: this?.applicationId,
        pageChildWidgetOrderList: newChildOrderWidgetList,
        pageChildRestrictedWidgetOrderList: this?.pageChildRestrictedWidgetOrderList,
      };
      // if(notSideBar && !this?.isOnlyReduxUpdate) {
      //   this?.updatePageDtlsfn({
      //       reqObj: reqObj
      //   });
      // }
      const currentPageDtlsObj = {
        ...currentPageDtls,
        //undoStepValue: this?.currentPageDtls?.undoStepValue + 1,
        //redoStepValue: 0,
        ...reqObj,
      };
      this?.dispatch(this?.updateCurrentPageDtls(currentPageDtlsObj));
      if (
        !notSideBar &&
        (this?.newWidgetData?.pageReusableWidgetId === null ||
          this?.newWidgetData?.pageReusableWidgetId === undefined)
      ) {
        this?.dispatch(
          this?.updateActivePageWidgetList({
            activePageId: currentPageDtls?.pageId,
            newWidgetList: [...this?.updatedWidgetDetails],
          }),
        );
      }

      if (notSideBar && (droppedFromContainerToMainCanvas || droppedFromMainCanvasToContainer)) {
        // pageList[this?.currentActivePageIndex].pageWidgetDtlsList = this?.updatedWidgetDetails;
        // pageList[currentPageIndex].pageWidgetDtlsList = this?.updatedWidgetDetails;
        let parentWidgetId =
          this?.widgetOrder?.currentParentWidgetId || this?.widgetOrder?.prevParentWidgetId;
        let parentWidgetIndex = this?.updatedWidgetDetails?.findIndex(
          widgetObj => widgetObj?.widgetId === parentWidgetId,
        );
        this.updatedWidgetDetails[parentWidgetIndex].childWidgetOrderList = this?.widgetOrder
          ?.currentParentWidgetId
          ? this?.widgetOrder?.currentChildWidgetOrderedList
          : this?.widgetOrder?.prevChildWidgetOrderedList;
        this?.dispatch(
          this?.updateActivePageWidgetList({
            activePageId: currentPageDtls?.pageId,
            newWidgetList: [...this?.updatedWidgetDetails],
          }),
        );
      }

      // this?.dispatch(
      //   this?.setPageEditorModelData({
      //     pageEditorModelData: pageList,
      //   }),
      // );
    }
    if (
      !this?.isPageChildWidgetOrderList ||
      droppedFromContainerToMainCanvas ||
      droppedFromMainCanvasToContainer
    ) {
      if (!droppedFromContainerToMainCanvas && !droppedFromMainCanvasToContainer) {
        this?.dispatch(
          this?.updateActivePageWidgetList({
            activePageId: currentPageDtls?.pageId,
            newWidgetList: [...this?.updatedWidgetDetails],
          }),
        );
      }
      if (
        notSideBar &&
        (this?.droppedFromOneContainerToAnother ||
          droppedFromContainerToMainCanvas ||
          droppedFromMainCanvasToContainer)
      ) {
        (async () => {
          // await this?.updateWidgetApiCall({
          //   requestConfig: this?.newWidgetData,
          // });
          // await this?.updateWidgetContainerApiCall({
          //   requestConfig: {
          //     widgetId: this?.newWidgetData?.widgetId,
          //     parentContainerWidgetId: this?.widgetOrder?.currentParentWidgetId,
          //   },
          // });
          // await this?.UpdateParentWidgetOrderReduxandAPI.call({
          //   widgetOrder: this?.widgetOrder,
          //   updateWidgetOrderApiCall: this?.updateWidgetOrderApiCall,
          //   droppedFromContainerToMainCanvas,
          //   droppedFromMainCanvasToContainer
          // })
        })();
        requestConfig.parentContainerWidgetId = this?.widgetOrder?.currentParentWidgetId;
        if (
          this?.widgetOrder?.currentParentWidgetId &&
          this?.widgetOrder?.currentChildWidgetOrderedList
        ) {
          requestConfig.parentContainerChildWidgetOrderList =
            this?.widgetOrder?.currentChildWidgetOrderedList;
        }
      } else {
        if (notSideBar) {
          requestConfig.parentContainerWidgetId = this?.parentContainerWidgetId;
          requestConfig.parentContainerChildWidgetOrderList = this?.childOrderWidgetList;
          // this?.updateWidgetOrderApiCall({
          //     requestConfig: {
          //         widgetId: this?.parentContainerWidgetId,
          //         childWidgetOrderList: this?.childOrderWidgetList,
          //         updatePropsVal:"childWidgetOrderedList"
          //       }
          // })
        }
      }
    }

    if (notSideBar && !this?.isOnlyReduxUpdate) {
      this?.updateWidgetDetailsApiCall({
        requestConfig: requestConfig,
      });
    }

    if (this?.newWidgetData?.dragFrom === 'sidebar') {
      this?.dispatch(
        this?.updateSelectedWidget({
          widgetId: this?.newWidgetData?.widgetId,
          name: `${this?.newWidgetData?.widgetUniqueCodeForPage}`,
          type: `${this?.newWidgetData?.widgetCode}`,
          widgetHtmlId: `${this?.newWidgetData?.widgetCode}`,
        }),
      );
    }

    setTimeout(() => {
      if (this?.newWidgetData?.widgetCode == widgetDataConstant.Popover) {
        this?.dispatch(updateVisiblePopover(this?.newWidgetData?.widgetId));
      }
    }, 100);
  }
};

export const UpdateParentWidgetOrderReduxandAPI = function () {
  const { widgetOrder, updateWidgetOrderApiCall } = this || {};
  if (widgetOrder?.prevParentWidgetId && widgetOrder?.prevChildWidgetOrderedList) {
    updateWidgetOrderApiCall({
      requestConfig: {
        widgetId: widgetOrder?.prevParentWidgetId,
        childWidgetOrderList: widgetOrder?.prevChildWidgetOrderedList,
        updatePropsVal: 'childWidgetOrderedList',
      },
    });
  }
  if (widgetOrder?.currentParentWidgetId && widgetOrder?.currentChildWidgetOrderedList) {
    updateWidgetOrderApiCall({
      requestConfig: {
        widgetId: widgetOrder?.currentParentWidgetId,
        childWidgetOrderList: widgetOrder?.currentChildWidgetOrderedList,
        updatePropsVal: 'childWidgetOrderedList',
      },
    });
  }
};

export const sectionWidgetApiAndReduxUPdate = async function () {
  //console.log('logging widget :', this?.finalResult);
  const state = store.getState();
  let sectionTemplateData = state?.pageEditor?.sectionTemplateData
    ? Object.values(state?.pageEditor?.sectionTemplateData)?.reduce((acc, subArray) => {
        return acc.concat(subArray?.templates);
      }, [])
    : state?.pageEditor?.sectionTemplateData;
  let expandedSectionTemplateData = state?.pageEditor?.expandedSectionTemplateData;
  let widgetStyleDtls = {};
  let index = sectionTemplateData?.findIndex(
    section => section?.pageSectionId === this?.finalResult?.pageSectionId,
  );
  if (index < 0) {
    index = expandedSectionTemplateData?.findIndex(
      section => section?.pageSectionId === this?.finalResult?.pageSectionId,
    );
    widgetStyleDtls = {
      ...expandedSectionTemplateData?.[index]?.parentContainerWidgetDtls?.widgetStyleDtls,
      x: this?.finalResult?.widgetStyleDtls?.x,
      y: this?.finalResult?.widgetStyleDtls?.y,
    };
  } else {
    widgetStyleDtls = {
      ...sectionTemplateData?.[index]?.parentContainerWidgetDtls?.widgetStyleDtls,
      x: this?.finalResult?.widgetStyleDtls?.x,
      y: this?.finalResult?.widgetStyleDtls?.y,
    };
  }
  const url = 'pagedesigner/pagesectiontemplate/addwidgetfromsectiontemplate';
  const usrActionId = uuid();
  const copyRandomId = uuid();
  const primaryUsrActionId = uuid();
  const request = {
    pageId: this?.pageId,
    applicationId: this?.applicationId,
    tenantId: this?.tenantId,
    pageSectionId: this?.finalResult?.pageSectionId,
    widgetStyleDtls: widgetStyleDtls,
    usrActionId: usrActionId,
    copyRandomId: copyRandomId,
    primaryUsrActionId: this?.primaryUsrActionId || primaryUsrActionId,
    ...(this?.finalResult?.parentContainerWidgetId && {
      parentContainerWidgetId: this?.finalResult?.parentContainerWidgetId,
    }),
  };
  const res = await this?.axiosFetch({
    axiosInstance: this?.axios,
    method: 'POST',
    url: `${this?.apiBackendBaseUrl}${url}`,
    requestConfig: request,
  });

  // refresh page
  const reqObj = { applicationId: this?.applicationId };
  const reqPageSectionData = {
    pageSectionId: this?.finalResult?.pageSectionId,
    newWidgetId: this?.finalResult?.widgetId,
    isDropInParentContainer: this?.isDropInParentContainer,
    finalResult: this?.finalResult,
    updateWidgetDetailsApiCall: this?.updateWidgetDetailsApiCall,
  };
  if (this?.isDropInParentContainer) {
    reqPageSectionData.childOrderWidgetList =
      this?.finalResult?.parentContainerChildWidgetOrderList;
  } else {
    reqPageSectionData.pageChildWidgetOrderList = this?.finalResult?.pageChildWidgetOrderList;
  }
  this?.getPageDtlsfn(reqObj, {
    ...reqPageSectionData,
  });
};

export const reusableWidgetApiAndReduxUPdate = async function () {
  const url = 'pagedesigner/pagereusablewidgetinfo/addpagereusablewidgetaspagewidget';
  const usrActionId = uuid();
  const copyRandomId = uuid();
  const reusablePrimaryUsrActionId = uuid();
  const pageEditorModelData = store?.getState()?.pageEditorModelData?.pageEditorModelData || [];
    const activePageFindIndex = pageEditorModelData?.findIndex(value => value.pageId === this?.pageId);
    const pageEditorModelDataState = pageEditorModelData?.[activePageFindIndex]?.pageWidgetDtlsList|| []
  let draftedPageId = null;
      draftedPageId = pageEditorModelDataState?.filter(
        widgetDtls => widgetDtls?.widgetId === widgetDtls?.parentContainerWidgetId,
      )[0]?.pageId;
  const request = {
    publishedMasterWidgetId: this?.finalResult?.publishedMasterWidgetId,
    draftedMasterWidgetId: this?.finalResult?.draftedMasterWidgetId,
    pageId: draftedPageId ? draftedPageId : this?.pageId,
    applicationId: this?.applicationId,
    tenantId: this?.tenantId,
    usrActionId: usrActionId,
    copyRandomId: copyRandomId,
    primaryUsrActionId: this?.primaryUsrActionId || reusablePrimaryUsrActionId,
    reusableWidgetId: this?.finalResult?.pageReusableWidgetId,
    widgetStyleDtls: this?.finalResult?.widgetStyleDtls,
    ...(this?.finalResult?.parentContainerWidgetId && {
      parentContainerWidgetId: this?.finalResult?.parentContainerWidgetId,
    }),
  };

  const res = await this?.axiosFetch({
    axiosInstance: this?.axios,
    method: 'POST',
    url: `${this?.apiBackendBaseUrl}${url}`,
    requestConfig: request,
  });

  let updatedPageChildWidgetOrderList = null;
  if(this?.finalResult?.parentContainerWidgetId === null || this?.finalResult?.parentContainerWidgetId === undefined) {
    const indexToReplace = this?.finalResult?.pageChildWidgetOrderList?.findIndex(
      widgetId => widgetId === this?.finalResult?.widgetId,
    );
    const pageIndex = res?.pageDtlsList?.findIndex(
      page => page?.pageId === this?.finalResult?.pageId,
    );
    const toAddId = res?.pageDtlsList?.[pageIndex]?.pageChildWidgetOrderList?.filter(
      widgetId => !this?.finalResult?.pageChildWidgetOrderList?.includes(widgetId),
    )[0];
    updatedPageChildWidgetOrderList = [...this?.finalResult?.pageChildWidgetOrderList];
    updatedPageChildWidgetOrderList[indexToReplace] = toAddId;
  }

  // const updatePageDtlsReq = {
  //   pageId: this?.pageId,
  //   applicationId: this?.applicationId,
  // };

  // await this?.updatePageDtlsfn({
  //   reqObj: { ...updatePageDtlsReq, pageChildWidgetOrderList: updatedPageChildWidgetOrderList },
  // });
  // refresh page
  const reqObj = { applicationId: this?.applicationId };
  this?.getPageDtlsfn(reqObj, null, updatedPageChildWidgetOrderList);
};

export const getDataDtls = dataList => {
  let dataPropObj = {};
  dataList?.map(obj => {
    const code = obj?.propCode;

    const newObj = obj;
    dataPropObj = { ...dataPropObj, [code]: newObj };
  });
  return dataPropObj;
};

export const getColorProps = (appearance, themePresetsandProps) => {
  const styleProps = appearance?.style?.styleProps;
  const usedProps = appearance?.style?.usedProps;
  const themeProps = appearance?.style?.themeProps;
  let colorPropsPropCodeList = [];
  let colorPropsObj = {};
  const propType = usedProps?.filter(val => val?.propCode === 'style')?.[0]?.style;
  const isCustom = propType === 'Custom';
  styleProps?.map(val => {
    if (val?.category === 'color') {
      colorPropsPropCodeList?.push(val?.propCode);
    }
  });
  const getColor = propObj => {
    const colorValue = isCustom
      ? getCustomColor({
          color: propObj?.color,
          opacity: propObj?.opacity,
          themePresetsandProps: themePresetsandProps,
        })
      : themePresetsandProps?.[themeProps?.[propObj?.propCode]?.replace('pre-', '')];
    return colorValue;
  };
  const getColorProperties = () => {
    colorPropsPropCodeList?.map(e => {
      const propObj = usedProps?.filter(val => val?.propCode === e)?.[0];
      //console.log('getColorProperties', propObj);
      const RGBAColor = getColor(propObj);
      colorPropsObj[e] = RGBAColor;
    });
    return colorPropsObj;
  };
  const colorPropsList = getColorProperties();
  return colorPropsList;
};

export const getFontPresets = (presetList, themePresetsandProps) => {
  let fontPresets = {};
  presetList?.map(preset => {
    const FontProps = themePresetsandProps?.[preset];

    const styleObj = getFontStyleandFontWeight({
      fntStyl: FontProps?.fontStyle,
    });
    fontPresets = {
      ...fontPresets,
      [preset]: {
        fontFamily: `${themePresetsandProps?.font}`,

        fontSize: `${Math.round(FontProps?.fontSize)}px`,
        fontStyle: styleObj?.fontStyle,
        fontWeight: styleObj?.fontWeight,
        lineHeight: FontProps?.lineHeight,
        letterSpacing: `${FontProps?.letterSpacing}px`,
      },
    };
  });
  return fontPresets;
};
export const getSegmentsList = ({ options, ref }) => {
  const segmentsList = [];
  options?.map(e => {
    segmentsList?.push({
      label: e,
      value: e,
      ref: ref,
    });
  });

  return segmentsList;
};
export const getSegmentPosition = ({ options, propValue }) => {
  const index = options?.findIndex(val => val === propValue);
  return index;
};

export const getCrnrBrdrShdw = (appearance, themePresetsandProps) => {
  const styleProps = appearance?.style?.styleProps;
  const usedProps = appearance?.style?.usedProps;
  const themeProps = appearance?.style?.themeProps;
  const propType = usedProps?.filter(val => val?.propCode === 'style')?.[0]?.style;
  const isCustom = propType === 'Custom';

  let crnrBrdrShdwObj = {};
  ['Corner', 'Shadow', 'Stroke']?.map(e => {
    //console.log('crnrBrdrShdwObj e isCustom', isCustom);
    const objKey = e === 'Stroke' ? 'getThemeBorder' : `getTheme${e}`;
    const reqObj = {
      [objKey]: themeProps?.[e === 'Stroke' ? 'border' : e?.toLowerCase()],
      color: e === 'Stroke' ? themeProps?.borderColor : '',
    };
    const keyVal = e === 'Stroke' ? 'border' : e?.toLowerCase();
    const obj = findStylePropVal({
      list: usedProps,
      code: e === 'Stroke' ? 'border' : e?.toLowerCase(),
      themePresetsandProps: themePresetsandProps,
      obj: reqObj,
      isCustom: isCustom,
    });
    crnrBrdrShdwObj = {
      ...crnrBrdrShdwObj,
      [keyVal]: obj,
    };
  });
  return crnrBrdrShdwObj;
};
export const widgetStyleDetailsResponsiveFn = function () {
  const responsiveWidthSize = {
    desktop: 1200,
    tabletLandscape: 992,
    tabletPortrait: 768,
    mobile: 390,
  };

  const widgetStyleDetailsResponsive = {
    desktop: DESKTOPRES,
    tabletPortrait: 'tabPortraitWidgetStyleDtls',
    tabletLandscape: 'tabLandscapeWidgetStyleDtls',
    mobile: 'mobileWidgetStyleDtls',
  };

  const findDeviceSize = () => {
    let device;
    Object.keys(responsiveWidthSize).forEach(value => {
      if (responsiveWidthSize[value] === Number(this?.pageWidth)) {
        device = value;
      }
    });
    return device;
  };

  const _findDeviceSize = findDeviceSize();
  if (this?.isDeviceTypeOnlyRequired) {
    return _findDeviceSize;
  }
  return widgetStyleDetailsResponsive[_findDeviceSize];
};

export const checkStringAndConvertToObject = currentPageProperties =>
  currentPageProperties &&
  typeof currentPageProperties === 'string' &&
  currentPageProperties?.trim()?.length > 0
    ? JSON.parse(currentPageProperties)
    : currentPageProperties;

export const currentPagePropertiesFn = function () {
  const selectedWidgetDtls = this?.selectedWidgetDtls;
  const currentResponsiveDeviceStyleProp = this?.currentResponsiveDeviceStyleProp;
  let result = {
    ...selectedWidgetDtls?.widgetStyleDtls,
  };
  if (currentResponsiveDeviceStyleProp === 'tabLandscapeWidgetStyleDtls') {
    result = {
      ...result,
      ...checkStringAndConvertToObject(selectedWidgetDtls?.tabLandscapeWidgetStyleDtls),
    };
  } else if (currentResponsiveDeviceStyleProp === 'tabPortraitWidgetStyleDtls') {
    result = {
      ...result,
      ...checkStringAndConvertToObject(selectedWidgetDtls?.tabLandscapeWidgetStyleDtls),
      ...checkStringAndConvertToObject(selectedWidgetDtls?.tabPortraitWidgetStyleDtls),
    };
  } else if (currentResponsiveDeviceStyleProp === 'mobileWidgetStyleDtls') {
    result = {
      ...result,
      ...checkStringAndConvertToObject(selectedWidgetDtls?.tabLandscapeWidgetStyleDtls),
      ...checkStringAndConvertToObject(selectedWidgetDtls?.tabPortraitWidgetStyleDtls),
      ...checkStringAndConvertToObject(selectedWidgetDtls?.mobileWidgetStyleDtls),
    };
  }
  return result;
};

export function deepMergeObj(list1, list2) {
  const list2keys = list2 && Object.keys(list2);
  const list1Clone = JSON.parse(JSON.stringify(list1));
  list2keys &&
    list2keys?.forEach(value => {
      if (value && list2[value] && list2[value].constructor.name === 'Object') {
        list1Clone[value] = {
          ...list1Clone[value],
          ...list2[value],
        };
      } else {
        list1Clone[value] = list2[value];
      }
    });
  return list1Clone;
}
export function deepMergeGroupObj(list1, list2, groupName) {
  const list2keys = list2 && list2[groupName] && Object.keys(list2 && list2[groupName]);
  const list1Clone = JSON.parse(JSON.stringify(list1));
  list2keys?.forEach(value => {
    if (
      value &&
      list2 &&
      list2[groupName][[value]] &&
      list2[groupName][[value]].constructor.name === 'Object'
    ) {
      list1Clone[value] = {
        ...list1Clone[value],
        ...list2[groupName][[value]],
      };
    } else {
      list1Clone[value] = list2[groupName][[value]];
    }
  });
  return list1Clone;
}
export function mergeArrayOfObjectWithoutDuplicate(list1, list2, prop, listIsArray, groupName) {
  // debugger;
  let reduced;
  if (listIsArray && Array.isArray(list1) && Array.isArray(list2)) {
    reduced = list1?.map(list1Item => {
      let currentListItem = list2?.find(list2Item => list2Item?.propCode === list1Item?.propCode);
      //console.log("currentListItem test test: ",list1Item?.propCode," ",list2," ", currentListItem)
      let result = {
        ...list1Item,
        ...currentListItem,
      };
      return result;
    });
    return reduced;
  } else {
    // reduced = {
    //   ...list1,
    //   ...list2
    // }
    if (groupName) {
      reduced =
        list2 && list2 !== undefined && list2[groupName]
          ? deepMergeGroupObj(list1, list2, groupName)
          : deepMergeObj(list1, list2);
    } else {
      reduced = deepMergeObj(list1, list2);
    }
    return reduced;
  }
}
// export function mergeArrayOfObjectWithoutDuplicate1(list1, list2, prop, listIsArray) {
//   // debugger;
//   let reduced;
//   if(listIsArray && Array.isArray(list1) && Array.isArray(list2)) {
//     reduced = list1?.filter(list1Item => !list2?.find(list2Item => {
//       return prop && list1Item?.[prop] === list2Item?.[prop]
//     }));
//     return reduced.concat(list2);
//   } else {
//     // reduced = {
//     //   ...list1,
//     //   ...list2
//     // }
//     reduced = deepMergeObj(list1, list2)
//     return reduced;
//   }
// }
// export function getCurrentUsedProps() {
//   // debugger;
//   if(this?.isDebugg) {
//     console.log(this?.isDebugg);
//   }
//   const apearenceResponsiveConstantKeyList = Object.keys(this?.apearenceResponsiveConstant);

//   const apearence = this?.apearence;
//   const apearenceProp = this?.apearenceProp;
//   const apearenceSubProp = this?.apearenceSubProp;
//   const apearenceObj = apearenceProp ? apearence?.[apearenceProp] : apearence;
//   const apearenceSubObj = apearenceObj?.[apearenceSubProp];
//   let result = apearenceSubObj;
//   let newResult = JSON.parse(JSON.stringify(apearenceSubObj));
//   console.log("apearenceObj check: ", apearenceSubObj);
//   console.log("styleUsedPropsKeyList check: ", apearenceResponsiveConstantKeyList?.length);
//   for(let i=0; i<apearenceResponsiveConstantKeyList?.length; i++) {
//     // debugger;
//     console.log("styleUsedPropsKeyList for apearenceObj: ", apearenceObj);
//     console.log("styleUsedPropsKeyList for: ", apearenceObj?.[this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]]);
//     if(i > 0) {
//       if(Array.isArray(result)) {
//         result?.forEach(value => {
//           if(value && Object.keys(value)?.length > 0) {
//             result = mergeArrayOfObjectWithoutDuplicate(result, apearenceObj?.[this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]],value?.propCode, true)
//             console.log("newResult check: ", result);
//           }
//         })
//       } else if(this?.isNonObject) {
//         const _result = apearenceObj[this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]];
//         result = _result !== null || _result !== undefined ? _result : result;
//       }else {
//         if(result && Object.keys(result)?.length > 0) {
//           const currentWidgetDtlsObj = apearenceObj?.[this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]];
//           const currentWidgetDtlsObjParse = typeof currentWidgetDtlsObj === "string" ? JSON.parse(currentWidgetDtlsObj) : currentWidgetDtlsObj
//           result = mergeArrayOfObjectWithoutDuplicate(result,currentWidgetDtlsObjParse ,null, false)
//           console.log("newResult check: ", result);
//         }
//       }
//     }
//     if(apearenceResponsiveConstantKeyList[i] === this?.currentResponsiveDeviceStyleProp) {
//       break;
//     }
//   }
//   console.log("getCurrentUsedProps result: ", result);
//   return result;
// }
export function getCurrentUsedProps() {
  // debugger;
  if (this?.isDebugg) {
    // console.log(this?.isDebugg);
  }
  const apearenceResponsiveConstantKeyList = Object.keys(this?.apearenceResponsiveConstant);

  const apearence = this?.apearence;
  const apearenceProp = this?.apearenceProp;
  const apearenceSubProp = this?.apearenceSubProp;
  const apearenceObj = apearenceProp ? apearence?.[apearenceProp] : apearence;
  const apearenceSubObj = apearenceObj?.[apearenceSubProp];
  let result = apearenceSubObj;
  // let newResult = JSON.parse(JSON.stringify(apearenceSubObj));
  //console.log("apearenceObj check: ", apearenceSubObj);
  //console.log("styleUsedPropsKeyList check: ", apearenceResponsiveConstantKeyList?.length);
  for (let i = 0; i < apearenceResponsiveConstantKeyList?.length; i++) {
    // debugger;
    //console.log("styleUsedPropsKeyList for apearenceObj: ", apearenceObj);
    //console.log("styleUsedPropsKeyList for: ", apearenceObj?.[this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]]);
    if (i > 0) {
      if (Array.isArray(result)) {
        // result?.forEach(value => {
        //   if(value && Object.keys(value)?.length > 0) {
        //     result = mergeArrayOfObjectWithoutDuplicate(result, apearenceObj?.[this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]],value?.propCode, true)
        //     console.log("newResult check: ", result);
        //   }
        // })
        result = mergeArrayOfObjectWithoutDuplicate(
          result,
          apearenceObj?.[this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]],
          null,
          true,
          this?.groupName,
        );
        //console.log("newResult check: ",this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]," ", result);
      } else if (this?.isNonObject) {
        const _result =
          apearenceObj[this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]];
        result = _result !== null || _result !== undefined ? _result : result;
      } else {
        if (result && Object.keys(result)?.length > 0) {
          const currentWidgetDtlsObj =
            apearenceObj?.[
              this?.apearenceResponsiveConstant[apearenceResponsiveConstantKeyList[i]]
            ];
          // const currentWidgetDtlsObjParse =
          // currentWidgetDtlsObj && typeof currentWidgetDtlsObj === 'string'
          //     ? JSON.parse(currentWidgetDtlsObj)
          //     : currentWidgetDtlsObj;
          const currentWidgetDtlsObjParse = checkStringAndConvertToObject(currentWidgetDtlsObj);

          result = mergeArrayOfObjectWithoutDuplicate(
            result,
            currentWidgetDtlsObjParse,
            null,
            false,
            this?.groupName,
          );
          //console.log("newResult check: ", result);
        }
      }
    }
    if (apearenceResponsiveConstantKeyList[i] === this?.currentResponsiveDeviceStyleProp) {
      break;
    }
  }
  //console.log("getCurrentUsedProps result: ", result);
  return result;
}
export const getAppPageList = ({ appPageList, currentPageIndex, exCludeCurrentPage }) => {
  const list = [];
  const pageList = [...appPageList];
  if (exCludeCurrentPage) {
    pageList.splice(currentPageIndex, 1);
  }

  pageList.map(e => {
    const pageListObj = {
      pageName: e.pageName,
      pageUrlVal: e.pageUrlVal,
    };

    list.push(pageListObj);
  });
  return list;
};

export const axiosFetch = async configObj => {
  const { axiosInstance, method, url, requestConfig, defaultReqConfig, defaultCampignReqConfig } =
    configObj;
  try {
    // setLoading(true);
    const ctrl = new AbortController();
    // setController(ctrl);
    let res = '';

    if (method.toLowerCase() === 'get') {
      res = await axiosInstance[method.toLowerCase()](url, {
        headers: {
          'X-Data-Token': defaultReqConfig,
          'X-cmpgn-tkn': defaultCampignReqConfig,
        },
      });
    } else if (method.toLowerCase() === 'delete') {
      res = await axiosInstance[method.toLowerCase()](url, {
        headers: {
          'X-Data-Token': defaultReqConfig,
          'X-cmpgn-tkn': defaultCampignReqConfig,
        },
        ...requestConfig,
        signal: ctrl.signal,
      });
    } else {
      res = await axiosInstance[method.toLowerCase()](
        url,
        {
          ...requestConfig,
          signal: ctrl.signal,
        },
        {
          headers: {
            'X-Data-Token': defaultReqConfig,
            'X-cmpgn-tkn': defaultCampignReqConfig,
          },
        },
      );
    }
    // setResponse(res.data);
    return res.data;
  } catch (err) {
    // setError(err.message);
  } finally {
    // setLoading(false);
  }
};

export const getStateValByLS = () => {
  const getCommonData = () => {
    const commonData_LS = localStorage.getItem('persist:commonData');
    const commonData =
      commonData_LS && commonData_LS?.trim()?.length > 0 ? JSON.parse(commonData_LS) : null;
    const tenant =
      commonData?.tenant && commonData?.tenant?.trim()?.length > 0
        ? JSON.parse(commonData?.tenant)
        : null;
    const applicationId =
      commonData?.applicationId && commonData?.applicationId?.trim()?.length > 0
        ? JSON.parse(commonData?.applicationId)
        : null;
    const userProfile =
      commonData?.userProfile && commonData?.userProfile?.trim()?.length > 0
        ? JSON.parse(commonData?.userProfile)
        : null;
    const workspaceId =
      commonData?.workspaceId && commonData?.workspaceId?.trim()?.length > 0
        ? JSON.parse(commonData?.workspaceId)
        : null;

    const commonDataObj = {
      tenant: tenant,
      userProfile: userProfile,
      applicationId: applicationId,
      workspaceId: workspaceId,
    };
    return commonDataObj;
  };

  const getWorkspaceData = () => {
    const workSpace_LS = localStorage.getItem('persist:workSpace');

    const workSpace_LS_Parse =
      workSpace_LS && workSpace_LS?.trim()?.length > 0 ? JSON.parse(workSpace_LS) : null;

    const workspaceDataObj = {
      applicationName: workSpace_LS_Parse?.selectedAppName,
    };

    return workspaceDataObj;
  };

  return { getCommonData, getWorkspaceData };
};
export const debouncedHandleChangeText = debounce(prop => {
  console.log('debouncedHandleChangeText', prop?.propValue);

  prop?.textContentEditableOnChange({
    propCode: prop?.propCode,
    propValue: prop?.propValue,
  });
}, 5000);

export const getSectionIdList = function () {
  //debugger;
  const pageToBeNavigatedTo = this?.pageToBeNavigatedTo;
  const state = store?.getState();
  const getPageofScrollTo = pageToBeNavigatedTo
    ? state?.pageEditorModelData?.pageEditorModelData?.find(
        pageVal => pageVal?.pageUrlVal === pageToBeNavigatedTo,
      )
    : state?.pageEditorModelData?.pageEditorModelData?.find(
        pageVal => pageVal?.pageId === this?.pageId,
      );
  const result = getPageofScrollTo?.pageWidgetDtlsList
    ?.filter(widgetVal => widgetVal?.widgetCode === 'Section')
    ?.map(widgetVal =>
      this?.isArrStr
        ? widgetVal?.widgetHtmlId
        : {
            widgetHtmlId: widgetVal?.widgetHtmlId,
            widgetName: widgetVal?.widgetName,
          },
    );
  return result;
};
export const getWidgetCommonDtls = ({ widgetId, code, pageWidgetDtlsList }) => {
  const activeWidgetIndex = pageWidgetDtlsList?.findIndex(val => val.widgetId === widgetId);
  const newObj = activeWidgetIndex !== -1 ? pageWidgetDtlsList[activeWidgetIndex] : [];

  return newObj?.[code] || '';
};

export const postMethod = async ({ url, req, type, axios, defaultReqConfig }) => {
  return await axios
    .post(url, req, {
      headers: {
        'Content-Type': type ? type : 'application/json',
        'X-Data-Token': defaultReqConfig,
      },
    })
    .then(res => {
      return res;
    })
    .catch(err => {
      if (axios.isCancel(err)) {
        // cLogger.log("cancelled!")
      }
      return err.response;
    });
};

export const getOldTextWidgetsIdList = pageTextWidgetsList => {
  const oldTextWidgetsIdList = pageTextWidgetsList?.map(e => {
    if (e?.widgetVersion === undefined || e?.widgetVersion === null) {
      return e?.widgetId;
    }
  });
  return oldTextWidgetsIdList;
};
export const findPropIndex = function ({ propCode, dataList }) {
  const index = dataList?.findIndex(val => val.propCode === propCode);
  return index;
};
export const formatDataInput = dataValue => {
  try {
    return typeof dataValue === 'object'
      ? dataValue
      : typeof dataValue === 'string' && JSON.parse(dataValue);
  } catch (error) {
    return null;
  }
};
export const calcWidgetPosition = function ({
  canvasWidth,
  widgetClientWidth,
  canvasHeight,
  widgetClientHeight,
  position,
}) {
  let leftVal = 0;
  let topVal = 0;
  let rightVal = 0;
  switch (position) {
    case LEFT_TOP:
      return { left: leftVal, top: topVal };
    case CENTER_TOP:
      leftVal = parseInt(canvasWidth) - parseInt(widgetClientWidth);
      leftVal = leftVal / 2;
      return { left: leftVal, top: topVal };
    case RIGHT_TOP:
      leftVal = parseInt(canvasWidth) - parseInt(widgetClientWidth);
      return { left: leftVal, top: topVal };
    case LEFT_CENTER:
      topVal = parseInt(canvasHeight) - parseInt(widgetClientHeight);
      topVal = topVal / 2;
      return { left: leftVal, top: topVal };
    case CENTER:
      leftVal = parseInt(canvasWidth) - parseInt(widgetClientWidth);
      leftVal = leftVal / 2;
      topVal = parseInt(canvasHeight) - parseInt(widgetClientHeight);
      topVal = topVal / 2;
      return { left: leftVal, top: topVal };
    case RIGHT_CENTER:
      topVal = parseInt(canvasHeight) - parseInt(widgetClientHeight);
      topVal = topVal / 2;
      return { left: `unset`, top: topVal, right: rightVal };
    case LEFT_BOTTOM:
      return { left: 0, top: `unset`, bottom: 0 };
    case CENTER_BOTTOM:
      leftVal = parseInt(canvasWidth) - parseInt(widgetClientWidth);
      leftVal = leftVal / 2;
      return { left: leftVal, top: `unset`, bottom: 0 };
    case RIGHT_BOTTOM:
      return { left: `unset`, top: `unset`, bottom: 0, right: 0 };
    default:
      return null;
  }
};
export const calcSliderWidgetPosition = function ({
  canvasWidth,
  widgetClientWidth,
  canvasHeight,
  widgetClientHeight,
  position,
}) {
  let leftVal = 0;
  let topVal = 0;
  let rightVal = 0;
  // let rightVal = 0;
  switch (position) {
    case LEFT:
      return { left: leftVal, top: topVal, height: '100%' };
    case RIGHT:
      return { left: `unset`, right: rightVal, top: topVal, height: '100%' };
    case TOP:
      return { left: leftVal, top: topVal, width: '100%' };
    case BOTTOM:
      return {
        left: `unset`,
        top: `unset`,
        bottom: 0,
        width: '100%',
      };
    default:
      return null;
  }
};
export const fontsList = [
  'Theme-Font',
  'Font-Awesome-6-Free',
  'Font-Awesome-6-Free-Regular',
  'Font-Awesome-6-Brands',
  'Alegreya',
  'Alegreya-Sans',
  'Aleo',
  'Amiri',
  'Anton',
  'Arapey',
  'Archivo',
  'Archivo-Narrow',
  'Assistant',
  'Barlow',
  'BioRhyme',
  'Bitter',
  'Brawler',
  'Cabin',
  'Caladea',
  'Cardo',
  'Carme',
  'Chivo',
  'Concert-One',
  'Cormorant',
  'Cormorant-Garamond',
  'Comic-Neue',
  'Crimson-Text',
  'Dancing-Script',
  'DM-Sans',
  'DM-Serif-Display',
  'Domine',
  'EB-Garamond',
  'Eczar',
  'Encode-Sans',
  'Encode-Sans-Semi-Condensed',
  'Enriqueta',
  'Engagement',
  'Epilogue',
  'Figtree',
  'Fira-Sans',
  'Frank-Ruhl-Libre',
  'Gelasio',
  'Hahmlet',
  'Headland-one',
  'IBM-Plex-Sans',
  'Inconsolata',
  'Inknut-Antiqua',
  'Inter',
  'Josefin-Sans',
  'Karla',
  'Londrina-Solid',
  'Lato',
  'Lexend-Deca',
  'Libre-Baskerville',
  'Libre-Franklin',
  'Literata',
  'Lora',
  'Maitree',
  'Manrope',
  'Merriweather',
  'Montserrat',
  'Mulish',
  'Nanum-Gothic',
  'Neuton',
  'Noto-Sans',
  'Noto-Serif',
  'Nunito-Sans',
  'Open-Sans',
  'Oswald',
  'Oxanium',
  'Oxygen',
  'Pacifico',
  'Playfair-Display',
  'Plus-Jakarta-Sans',
  'Poiret-One',
  'Poly',
  'Poppins',
  'Prompt',
  'Proza-Libre',
  'PT-Sans',
  'PT-Serif',
  'Quattrocento',
  'Raleway',
  'Red-Hat-Display',
  'Roboto',
  'Roboto-Condensed',
  'Roboto-Serif',
  'Rokkitt',
  'Rubik',
  'Russo-One',
  'Sora',
  'Source-Sans-3',
  'Source-Serif-4',
  'Space-Grotesk',
  'Space-Mono',
  'Spectral',
  'Syne',
  'Titillium-Web',
  'Ubuntu',
  'Urbanist',
  'Vast-Shadow',
  'Work-Sans',
  'Zilla-Slab',
  'Quicksand' 
];

const getFontsStyle = props => {
  return fontsList
    .map(
      font => `
      ${
        props?.component === 'RTE'
          ? `
        .ql-picker.ql-font .ql-picker-label[data-value="${font}"]::before,
    .ql-picker.ql-font .ql-picker-item[data-value="${font}"]::before {
      font-family: '${
        font === 'Theme-Font' ? props?.themeFont 
        :['Font-Awesome-6-Free', 'Font-Awesome-6-Free-Regular','Font-Awesome-6-Brands']?.includes(font) 
        ?'Open Sans 3'
        : font?.replaceAll('-', ' ')
      }' !important;
      content: '${font?.replaceAll('-', ' ')}' !important;
       height:20px;
  overflow:hidden;


    } `
          : ''
      }
    
    .ql-font-${font} {
       font-family: '${
         font === 'Theme-Font'
           ? props?.themeFont
           : ['Font-Awesome-6-Free-Regular']?.includes(font)
           ? 'Font Awesome 6 Free'
           : font?.replaceAll('-', ' ')
       }' !important;
    }
   
   `,
    )
    .join('\n');
};

export const lineHeightList = [
  '1.0',
  '1.25',
  '1.5',
  '1.75',
  '2',
  '2.25',
  '2.5',
  '2.75',
  '3',
  '3.25',
  '3.5',
  '3.75',
  '4',
  '6',
  '8',
  '10',
];
export const letterSpacingList = [
  '0px',
  '0.5px',
  '0.75px',
  '1px',
  '1.25px',
  '1.5px',
  '1.75px',
  '2px',
  '2.25px',
  '2.5px',
  '3px',
];
export const faIconsList=[
  "fa-phone",
 "fa-envelope",
 "fa-house",
 "fa-location-dot",
 "fa-user",
 "fa-mobile",
 "fa-comment",
 "fa-cart-shopping",
 "fa-bell",
 "fa-check",
 "fa-instagram",
 "fa-youtube",
 "fa-facebook",
 "fa-linkedin",
 "fa-square-twitter",
 "fa-reddit",
 "fa-apple"
]
export const faSolidIcons=[
  "fa-phone",
 "fa-envelope",
 "fa-house",
 "fa-location-dot",
 "fa-user",
 "fa-mobile",
 "fa-comment",
 "fa-cart-shopping",
 "fa-bell",
 "fa-check",
]
export const faBrandIcons=[
  "fa-instagram",
 "fa-youtube",
 "fa-facebook",
 "fa-linkedin",
 "fa-square-twitter",
 "fa-reddit",
 "fa-apple"
]
const getLnhgtorLtrSpcngStyles = ({style,lnhgtorltrSpcingList,propName,component}) => {
  return lnhgtorltrSpcingList
    .map(
      val => `
      ${component==="RTE" ? `
        .ql-picker.ql-${style} .ql-picker-label[data-value="${val}"]::before{
         width :${style === 'lineHeight' ? '120px' :'153px'} !important;
            content: '${style === 'lineHeight' ? 'Line Height' :'Letter Spacing'} ${val}' !important;
         }
        }
        .ql-picker.ql-${style} .ql-picker-item[data-value="${val}"]::before {       
            content: '${val}' !important;
         }
            `
          :
          ``}
        
        .ql-${style}-${val?.replace('.','p')} {
           ${propName} : ${val}
        }
  `,
    )
    .join('\n');
};


const lineHeightStyles = (props)=>{
  return getLnhgtorLtrSpcngStyles({style:'lineHeight',lnhgtorltrSpcingList:lineHeightList,propName:'line-height',component:props?.component})
}
const ltrSpcingStyles = (props)=>{
  return getLnhgtorLtrSpcngStyles
  ({style:'letterSpacing',lnhgtorltrSpcingList:letterSpacingList,propName:'letter-spacing',component:props?.component})
  
}

export const faIconStyles = ()=>{

  return  faIconsList?.map(icon=>
    `.ql-picker.ql-faIcon .ql-picker-label[data-value="${icon}"]::before{
     width :153px !important;
     content: '${icon}' !important;
  
 }
 .ql-picker.ql-faIcon .ql-picker-item[data-value="${icon}"]::before {       
     content: '${icon}' !important;
  }`
  ).join('\n');

}

export const StyledDiv = styled.div`
  ${props => {
    return props?.getFontSizeStyles ? props?.getFontSizeStyles : '';
  }}
  ${props => getFontsStyle(props)}
  ${props => ltrSpcingStyles(props)}
  ${props => lineHeightStyles(props)}
  ${props => faIconStyles(props)}
`;
export const fnUsedDataPropValue=()=>{
  const {dataList,propCode,attrCode}=this;
  const propValue=findPropValue({list:dataList,propCode:propCode,attrCode:attrCode})
  return propValue;
}
export const fnSlideBlockDisplay=function (){
  const {dataList}=this;
  const attrCode='propValue';
  const slideBlockShow=findPropValue({list:dataList,propCode:widgetDataConstant?.SlideBlockShow,attrCode:attrCode})
  const slideFromSelectedValue=findPropValue({list:dataList,propCode:'slideFrom',attrCode:'selectedValue'})
  const slideFromDtls = formatDataInput(slideFromSelectedValue);
  const slideFrom = slideFromDtls?.value;
  const slideAnimation=findPropValue({list:dataList,propCode:'slideAnimation',attrCode:attrCode})
  //const showClose=findPropValue({list:dataList,propCode:'showClose',attrCode:attrCode})
  let slideAnimationClass = "";
  let translateVal="";
  if(slideBlockShow)
  {
    if (slideAnimation) {
      if (slideFrom === "left") {
        translateVal = "disable-transform-left";
      } else if (slideFrom === "right") {
        translateVal = "disable-transform-right";
      } else if (slideFrom === "top") {
        translateVal = "disable-transform-top";
      } else if (slideFrom === "bottom") {
        translateVal = "disable-transform-bottom";
      }
      slideAnimationClass =`${translateVal} slider-transition display-block`;
    }
    else{
      slideAnimationClass=`transform-zero offslider-transition display-block`
    }
    }
    else
    {
      if (slideAnimation) {
        if (slideFrom === "left") {
          translateVal = "visible-transform-left";
        } else if (slideFrom === "right") {
          translateVal = "visible-transform-right";
        } else if (slideFrom === "top") {
          translateVal = "visible-transform-top";
        } else if (slideFrom === "bottom") {
          translateVal = "visible-transform-bottom";
        }
        slideAnimationClass =`${translateVal} slider-transition display-block`;
      }
      else{
        slideAnimationClass=`transform-zero offslider-transition display-none`
      }
      
      
    }
    
 return slideAnimationClass;
}

export const StyledDivEle = styled.div`
& > * {
    position: ${(props)=>props?.position} !important;
  }
::-webkit-scrollbar {
  width: ${(props)=>props?.scrlwidth}px;
  height:${(props)=>props?.scrlwidth}px;
}
::-webkit-scrollbar-track {
  background: ${(props)=>props?.scrlbse};
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: ${(props)=>props?.scrlbr};
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background:  ${(props)=>props?.scrlbr};
}
`
export function findParentWidgetData(widgets, widgetId, fieldName) {
  const widget = widgets?.find(widget => widget?.widgetId === widgetId);

  if (!widget || !widget?.parentContainerWidgetId) {
    return widget;
  }

  if (widget?.widgetCode === fieldName) {
      return widget;
  }

  return findParentWidgetData(widgets, widget?.parentContainerWidgetId, fieldName);
}